<script lang="ts" setup>
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.25 6.75C3.18579 6.75 1.5 8.43579 1.5 10.5V13.5C1.5 15.5642 3.18579 17.25 5.25 17.25H6V19.6074C6 20.4358 6.67157 21.1074 7.5 21.1074H9C9.82843 21.1074 10.5 20.4358 10.5 19.6074V17.25H11.0423L17.2283 20.9616C18.228 21.5615 19.5 20.8413 19.5 19.6754V4.32464C19.5 3.1587 18.228 2.43853 17.2283 3.0384L17.6054 3.66705L17.2283 3.0384L11.0423 6.75L5.25 6.75Z"
      fill="white"
      stroke="#4D4E58"
      stroke-width="1.5"
    />
    <path
      d="M23.6944 11.9027C23.6944 9.92924 22.8338 8.14871 21.4688 6.93201V16.8585C22.8338 15.6566 23.6944 13.8761 23.6944 11.9027Z"
      fill="#4D4E58"
    />
    <path
      d="M10.9875 12.75H1.5V10.9167L3.375 7.125H10.9875L18.75 3V8.625L10.9875 12.75Z"
      fill="#E0E5FF"
      stroke="#E0E5FF"
      stroke-width="0.75"
    />
    <path
      d="M5.25 6.75C3.18579 6.75 1.5 8.43579 1.5 10.5V13.5C1.5 15.5642 3.18579 17.25 5.25 17.25H6V19.6074C6 20.4358 6.67157 21.1074 7.5 21.1074H9C9.82843 21.1074 10.5 20.4358 10.5 19.6074V17.25H11.0423L17.2283 20.9616C18.228 21.5615 19.5 20.8413 19.5 19.6754V4.32464C19.5 3.1587 18.228 2.43853 17.2283 3.0384L17.6054 3.66705L17.2283 3.0384L11.0423 6.75L5.25 6.75Z"
      stroke="#4D4E58"
      stroke-width="1.5"
    />
  </svg>
</template>
